<template>
    <div class="row">
        <fieldset style="text-align: left;padding: 30px;">
            <div class="row">
                <div class="col-md-12 mb-2">
                    <h5>Event Assessment Execution</h5>
                </div>
            </div>
            <div class="row">
                <div v-if="this.updateTraining.typetraining_id == 1" class="d-flex flex-row bd-highlight mb-3" style="padding-left:12px">
    
                    <div class="bd-highlight">
                        <div class="form-check">
                            <vs-checkbox v-model="preAssesment" @change="handlePreChange($event)" >
                                <b>PreAssesment</b>
                                <br />
                                <span class="text-success">Enable</span>
                            </vs-checkbox>
                        </div>
                    </div>
                    <div class="bd-highlight">
                        <div class="form-check">
                            <vs-checkbox v-model="postAssesment" @change="handlePostChange($event)" :disabled="!preAssesment">
                                <b>PostAssesment</b>
                                <br />
                                <span class="text-success">Enable</span>
                            </vs-checkbox>
                        </div>
                    </div>
                    <div class="bd-highlight">
                        <div class="form-check">
                            <vs-checkbox v-model="traineefeedback" @change="handleFeedbackChange($event)" :disabled="!postAssesment">
                                <b>Feedback</b>
                                <br />
                                <span class="text-success">Enable</span>
                            </vs-checkbox>
                        </div>
                    </div>
                    <div class="bd-highlight">
                        <!-- <div class="form-check">
                            <vs-checkbox v-model="trainingStatus" @change="handleTrainingStatusChange($event)" :disabled="!traineefeedback">
                                <b>Event</b>
                                <br />
                                <span class="text-success">Closure</span>
                            </vs-checkbox>
                        </div> -->
                        <div class="form-check">
                                    <vs-checkbox
                                      v-model="trainingStatus"
                                      @change="handleTrainingStatusChange()"
                                      
                                    >
                                      <b>Event</b>
                                      <br />
                                      <span class="text-success">Closure</span>
                                    </vs-checkbox>
                                  </div>
                    </div>
    
                </div>
    
                <!-- --- -->
                <div v-else class="d-flex flex-row bd-highlight mb-3" style="padding-left:12px">
    
                    <div class="bd-highlight">
                        <div class="form-check">
                            <vs-checkbox v-model="trainingStatus" @change="handleTrainingStatusChange()">
                                <b>Event</b>
                                <br />
                                <span class="text-success">Closure</span>
                            </vs-checkbox>
                        </div>
                    </div>
    
                </div>
                <div class="table-responsive">
                    <div class="col-sm-12">
                        <!-- new form popup starts -->
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="scroll-table-container">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th>Sr#</th>
                                            <th>Name</th>
                                            <th>CNIC Number</th>
                                            <th>Contact Number</th>
                                            <th>Username</th>
                                            <th v-if="training_type == 1">Pre</th>
                                            <th v-if="training_type == 1">Post</th>
                                            <th>Potential Trainer</th>
                                        </tr>
                                        </thead>
                                        <tr v-for="(item, index) in itemsTrainee" v-bind:key="item.id">
                                            <td>{{index+1}}</td>
                                            <td v-if="item.name != null" class="text-capitalize">
                                                {{item.name}}
                                            </td>
                                            <td v-else>NULL</td>
                                            <td v-if="item.cnic != null">
                                                {{item.cnic}}
                                            </td>
                                            <td v-else>NULL</td>
                                            <td v-if="item.contactNo != null">
                                                {{item.contactNo}}
                                            </td>
                                            <td v-else>NULL</td>
                                            <td v-if="item.username != null">
                                                {{item.username}}
                                            </td>
                                            <td v-else>NULL</td>
                                            <td v-if="training_type == 1">
                                                <span v-if="item.preassesmentcheck =='found'">
                                                    <vs-icon class="mr-1" icon="check" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                </span>
                                                <vs-icon v-else class="mr-1" icon="close" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                            </td>
                                            <td v-if="training_type == 1">
                                                <span v-if="item.postassesmentcheck =='found'">
                                                    <vs-icon class="mr-1" icon="check" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                </span>
                                                <vs-icon v-else class="mr-1" icon="close" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                            </td>
                                            <td >
                                                  <label class="switch">
                                                           <input disabled type="checkbox" :id="'checkbox-' + item.id" :checked="item.potentialTrainer"  />
                                                           <span class="slider"></span>
                                                   </label>
                                           </td>
                                           
                                        </tr>
                                    </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- new form popup ends -->
                    </div>
                </div>
            </div>
        </fieldset>
    
         <!-- Add Modal -->
         <b-modal 
                v-model="showModal1" 
                title="Event Details" 
                size="lg" 
                @ok="handleSubmit"
                @cancel="handleCancel" 
                ok-title="Update"
                ok-variant="primary"
                cancel-variant="outline-secondary"
                header-bg-variant="light"
                header-text-variant="primary"
                hide-header-close
                centered>
                <template #modal-title>
                    <h4 class="color-06 mb-0">{{updateTraining.title}}</h4>
                </template>
                <div class="event-details">
                    <!-- Status Update Section -->
                    <div class="status-section p-3 bg-light rounded">
                        <h5 class="mb-3 color-06">Update Type</h5>
                        <div class="row mb-4">
                            <div class="col-4 font-weight-bold text-muted">Event Status:</div>
                            <div class="col-8">
                              <select 
                                    v-model="closure_status" 
                                    class="form-control form-control-lg"
                                    :class="{ 'is-invalid': submitted && !closure_status }">
                                    <option value="">Select Status</option>
                                    <option value="Completed">Completed</option>
                                    <option value="Cancelled">Cancelled</option>
                                    <option value="Postponed">Postponed</option>
                                </select>
                                
                            </div>
                        </div>
                        
                    </div>
                </div>
            </b-modal>
    
              <!-- Confrim Modal -->
              <b-modal 
                v-model="showModal2" 
                title="Confirm Status Change"
                @ok="eventStatusChange"
                @cancel="handleCancel" 
                ok-title="Yes"
                cancel-title="No"
                header-bg-variant="light"
                hide-header-close
                centered>
                <p>Are you sure you want to change the event status?</p>
              </b-modal>
    </div>
    </template>
    
    <script>
    
    import axios from "axios";
    
    export default {
        data: () => ({
    
            preAssesment: "",
            postAssesment: "",
            traineefeedback: "",
            trainingStatus: "",
            oldTrainingStatus: "",
            role: "",
            success: "",
            error: "",
            cnic: "",
            updateTraining: [],
            trainingId: "",
            trainingCode: "",
            roleuser: "",
            code: "",
            name: "",
            trainingArr: [],
            itemsTrainee: [],
            training_status: "",
            training_type: "",
            showModal1: false,
            showModal2: false,
    
        }),
        watch: {
    
        },
        mounted() {
            axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    
            this.trainingCode = this.$route.query.trainingId;
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/programOfficer/trainingsingle/get/" +
                    this.trainingCode
    
                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
    
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.updateTraining = response.data.training;
                    this.trainingId = response.data.training.id;
                    this.training_status = response.data.training.trainingstatus ?? '' ;
                    this.oldTrainingStatus = response.data.training.close_status ?? '';
                    this.training_type = response.data.training.typetraining_id;
    
                    this.allTrainer();
    
                    if (response.data.training) {
                        this.preAssesment = response.data.training.preassesment_status || this.preAssesment;
                        this.postAssesment = response.data.training.postassesment_status || this.postAssesment;
                        this.traineefeedback = response.data.training.feedbackstatus || this.traineefeedback;
                        this.trainingStatus = response.data.training.close_status || this.trainingStatus;
                    }
                });
    
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/traineeroles/get")
                .then(response => {
    
                    this.closeLoading();
                    this.role = response.data[0].id;
                });
            //select all Training Name
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/trainers/get")
                .then(response => {
    
                    this.closeLoading();
                    this.trainingArr = response.data;
                });
        },
        
    
        methods: {
            // onclick show wizard steps
        handleTrainingStatusChange() {
           if(this.trainingStatus == true){
             this.showModal1 = true;
             }else{
              this.showModal2 = true;
             }
    
        },
        handleCancel(){
              this.$nextTick(() => {
              this.trainingStatus = this.oldTrainingStatus;
             
              if (this.$refs.trainingCheckbox) {
                this.$refs.trainingCheckbox.$el.querySelector('input').checked = this.oldTrainingStatus;
              }
            });
            },
    
            handleSubmit() {
              
              if (!this.closure_status) {
                  this.toastError('Please select an event status');
                  return;
              }
    
              this.openLoading();
              axios.put(`${process.env.VUE_APP_BASE_PATH}/training/update-closure-status/${this.trainingId}`, {
                  closure_status: this.closure_status,
              })
              .then(response => {
                      this.closeLoading();
                      if (response.status === 200 && response.data) {
                          this.toastSuccess('Status updated successfully');
                          this.showModal1 = false;
                          this.confirmStatusChange(true);
                      } 
                  })
                  .catch(error => {
                    this.closeLoading();
                        if (error.response && error.response.status === 400) {
                            const errorMessage = error.response.data?.message || 'Invalid request data';
                            this.toastError(errorMessage);
                        } else {
                            this.toastError(error.response?.data?.message || 'Failed to update status');
                        }
                        this.handleCancel();
                        this.showModal1 = false;
                  });
          },
       eventStatusChange(){
            this.openLoading();
              axios.put(`${process.env.VUE_APP_BASE_PATH}/training/update-closure-status/${this.trainingId}`, {
                  closure_status: 'Planned',
              })
              .then(response => {
                      this.closeLoading();
                      if (response.status === 200 && response.data) {
                          this.toastSuccess('Status updated successfully');
                          this.showModal2 = false;
                          this.confirmStatusChange(false);
                      } 
                  })
                  .catch(error => {
                    this.closeLoading();
                        if (error.response && error.response.status === 400) {
                            const errorMessage = error.response.data?.message || 'Invalid request data';
                            this.toastError(errorMessage);
                        } else {
                            this.toastError(error.response?.data?.message || 'Failed to update status');
                        }
                        this.handleCancel();
                        this.showModal2 = false;
                  });
                },
                confirmStatusChange(data){
              axios
            .get(
              process.env.VUE_APP_BASE_PATH +
                "/close-training/" +
                this.trainingId +
                "/" +
                data
    
            )
            .then(response => {
              if(response.data.unAuth){
                this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                localStorage.clear();
                setTimeout(() => {
                    this.$router.push("/");
                }, 1000);
    
              }
              if(response.data.tokenExpired){
                // this.$toasted.global.errorMsg(response.data.tokenExpired);
                localStorage.clear();
                setTimeout(() => {
                    this.$router.push("/");
                }, 1000);
              }
              this.closeLoading();
            });
            },
    
            openLoading() {
                this.$vs.loading({
                    type: "material"
                });
            },
            closeLoading() {
                this.$vs.loading.close();
            },
            handlePreChange: function (e) {
                e.stopPropagation();
                e.preventDefault();
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/enable-preassesment/" +
                        this.trainingId +
                        "/" +
                        this.preAssesment
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            this.toastSuccess("Pre-assessment status updated successfully");
                        } else {
                            this.toastError(response.data.message || "Failed to update pre-assessment status");
                        }
                    })
                    .catch(error => {
                        this.closeLoading();
                        this.toastError(error.response?.data?.message || "An error occurred while updating pre-assessment status");
                    });
            },
            // handleTrainingStatusChange: function (e) {
            //     e.stopPropagation();
            //     e.preventDefault();
            //     this.openLoading();
            //     axios
            //         .get(
            //             process.env.VUE_APP_BASE_PATH +
            //             "/close-training/" +
            //             this.trainingId +
            //             "/" +
            //             this.trainingStatus
            //         )
            //         .then(response => {
            //             this.closeLoading();
            //             if (response.data.success) {
            //                 this.toastSuccess("Training status updated successfully");
            //             } else {
            //                 this.toastError(response.data.message || "Failed to update training status");
            //             }
            //         })
            //         .catch(error => {
            //             this.closeLoading();
            //             this.toastError(error.response?.data?.message || "An error occurred while updating training status");
            //         });
            // },
            handlePostChange: function (e) {
                e.stopPropagation();
                e.preventDefault();
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/enable-postassesment/" +
                        this.trainingId +
                        "/" +
                        this.postAssesment
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            this.toastSuccess("Post-assessment status updated successfully");
                        } else {
                            this.toastError(response.data.message || "Failed to update post-assessment status");
                        }
                    })
                    .catch(error => {
                        this.closeLoading();
                        this.toastError(error.response?.data?.message || "An error occurred while updating post-assessment status");
                    });
            },
            handleFeedbackChange: function (e) {
                e.stopPropagation();
                e.preventDefault();
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/enable-feedback/" +
                        this.trainingId +
                        "/" +
                        this.traineefeedback
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            this.toastSuccess("Feedback status updated successfully");
                        } else {
                            this.toastError(response.data.message || "Failed to update feedback status");
                        }
                    })
                    .catch(error => {
                        this.closeLoading();
                        this.toastError(error.response?.data?.message || "An error occurred while updating feedback status");
                    });
            },
            allTrainer: function allTrainer() {
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH + "/trainee/show/" + this.trainingId
    
                    )
                    .then(response => {
    
                        this.closeLoading();
    
                        this.itemsTrainee = response.data;
                    });
            },
            toastSuccess(msg) {
                this.$bvToast.toast(msg, {
                    title: "Success",
                    autoHideDelay: 10000,
                    variant: "success",
                    solid: true
                });
            },
            toastError(msg) {
                this.$bvToast.toast(msg, {
                    title: "Error",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true
                });
            },
            showinputvalue: function (event) {
                this.name = event.target.value;
            },
    
        }
    };
    </script>
    
    <style scoped>
    #msform fieldset {
        padding: 10px;
        background: #f7f7f7;
        border: 0 none;
        border-radius: 2rem;
        box-sizing: border-box;
        width: 100%;
        margin: 0;
        border: 2px solid #ccc;
        padding-bottom: 20px;
        position: relative;
    }
    
    #msform fieldset:not(:first-of-type) {
        display: none;
    }
    
    #msform fieldset .form-card {
        text-align: left;
        color: #9e9e9e;
    }
    
    select.list-dt {
        border: none;
        outline: 0;
        border-bottom: 1px solid #ccc;
        padding: 2px 5px 3px 5px;
        margin: 2px;
    }
    
    select.list-dt:focus {
        border-bottom: 2px solid skyblue;
    }
    .scroll-table-container {
  max-height: 300px;
  overflow-y: scroll;
  position: relative;
}

.scroll-table-container thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
}
    </style>
    